import React, { forwardRef, ElementType } from 'react';
import { Box, BoxProps, SliderProps } from '@mui/material';
import { flowThumbWidth } from './slider.theme';

export interface SliderContainer extends BoxProps<ElementType> {
  /**
   * Slider orientation
   */
  orientation?: SliderProps['orientation'];
  /**
   * Size of the slider thumb
   */
  thumbSize?: number;
}

/**
 * Simple wrapper of <Slider /> that ensures that thumb does not overflow outside the container
 */
export const SliderContainer: React.FC<SliderContainer> = forwardRef(
  ({ orientation, thumbSize = flowThumbWidth, sx, ...rest }, ref) => {
    return (
      <Box
        ref={ref}
        sx={{
          ...(orientation === 'vertical'
            ? {
                py: `${thumbSize / 2}px`,
                // increase the size of rail by size of thumb
                '& .MuiSlider-rail': {
                  height: 'auto',
                  top: `-${thumbSize / 2}px`,
                  bottom: `-${thumbSize / 2}px`,
                },
                // move track into increased rail size
                '& .MuiSlider-track': {
                  marginBottom: `-${thumbSize / 2}px`,
                  borderTopLeftRadius: '0',
                  borderTopRightRadius: '0',
                },
              }
            : {
                px: `${thumbSize / 2}px`,
                // increase the size of rail by size of thumb
                '& .MuiSlider-rail': {
                  width: 'auto',
                  left: `-${thumbSize / 2}px`,
                  right: `-${thumbSize / 2}px`,
                  maxWidth: 'none',
                },
                // move track into increased rail size
                '& .MuiSlider-track': {
                  marginLeft: `-${thumbSize / 2}px`,
                  borderTopRightRadius: '0',
                  borderBottomRightRadius: '0',
                },
              }),
          ...sx,
        }}
        {...rest}
      />
    );
  },
);
